import React from 'react';
import { Card } from '../ui/Card';
import { Check } from 'lucide-react';
export function ServicesSection() {
  const services = [{
    title: 'Ad Copy',
    description: 'High-CTR ad creatives for Facebook, Instagram, and LinkedIn that stop the scroll.',
    features: ['Multiple hooks/angles', 'Direct response style', 'Retargeting variations']
  }, {
    title: 'Email Sequences',
    description: 'Nurture sequences and launch campaigns that get opened, read, and clicked.',
    features: ['Welcome series', 'Launch sequences', 'Cart abandonment flows']
  }, {
    title: 'Sales Pages',
    description: 'Long-form sales letters that address every objection and close high-ticket offers on autopilot.',
    features: ['Objection handling', 'Psychological triggers', 'Mobile optimized layout']
  }, {
    title: 'Launch Copy',
    description: 'End-to-end messaging for your next big launch. From webinar scripts to social posts.',
    features: ['Webinar scripts', 'Social media swipe files', 'Landing page copy']
  }, {
    title: 'Social Caption Copy',
    description: 'Scroll-stopping captions for Instagram, LinkedIn, and Facebook that build authority and drive action.',
    features: ['Platform-specific tone', 'Hook-driven openers', 'CTA-optimized endings']
  }];
  return <section id="services" className="py-24 bg-slate-900 text-white" data-id="element-145" data-mp="3flrdgs6mf7jh">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-146" data-mp="30u8y8wll5h16">
        <div className="mb-16" data-id="element-147" data-mp="35tbqfgggvsrq">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-148" data-mp="35sk5czkhxdfp">
            Specialized Services for{' '}
            <span className="text-emerald-400" data-id="element-149" data-mp="3thv3086jurpm">Digital Creators</span>
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl" data-id="element-150" data-mp="25jwbgd0poef">
            Everything you need to monetize your audience effectively. No fluff,
            just deliverables that drive revenue.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-151" data-mp="72gw69kbci9h">
          {services.map((service, index) => <div key={index} className="bg-slate-800 rounded-xl p-8 border border-slate-700 hover:border-emerald-500/50 transition-colors group" data-id="element-152" data-mp="24nqdhmx9q9q" data-mpi={index}>
              <h3 className="text-2xl font-bold text-white mb-4 group-hover:text-emerald-400 transition-colors" data-id="element-153" data-mp="3p8lhsea2e8z0">
                {service.title}
              </h3>
              <p className="text-slate-300 mb-8 text-lg" data-id="element-154" data-mp="3fiiqciild32s">
                {service.description}
              </p>
              <ul className="space-y-3" data-id="element-155" data-mp="3ajp9cg43itxv">
                {service.features.map((feature, idx) => <li key={idx} className="flex items-center text-slate-400" data-id="element-156" data-mp="36fhnqrsxpu3v" data-mpi={idx}>
                    <Check className="w-5 h-5 text-emerald-500 mr-3" data-id="element-157" data-mp="31hg4o6viduse" />
                    {feature}
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>
    </section>;
}